// extracted by mini-css-extract-plugin
export var highlightOriginal = "_67-0";
export var highlightSuggested = "_67-1";